import { createFileRoute } from '@tanstack/react-router';
import styles from '../../components/documentation/DocContent.module.css';
import guideStyles from './StreamingGuide.module.css';

export const Route = createFileRoute('/documentation/streaming-guide-unity')({
  component: StreamingGuideUnityPage,
});

function StreamingGuideUnityPage() {
  return (
    <div className={guideStyles.page}>
      <div className={styles.breadcrumb}>Engine Guides</div>
      <h1 className={styles.pageTitle}>Streaming Guide (Unity)</h1>
      <p className={styles.pageSubtitle}>Coming soon.</p>
    </div>
  );
}
